// extracted by mini-css-extract-plugin
module.exports = {"search-fade-in":"BasicContentTabs_search-fade-in__Qs8gg"};